import * as React from 'react';
import cn from 'classnames';
import styles from './SearchForm.module.scss';
import messages from '../MetadataForm/messages';
import SchemaForm from '../SchemaForm';
import { ISubmitEvent } from '@rjsf/core';
import validateFormData from '@rjsf/core/lib/validate';
// import * as Sentry from '@sentry/react';
import { useIntl } from 'react-intl';
import SearchFormData from './SearchFormData';

type SearchFormProps = {
  className?: string;
  schema?: any;
  metadata: any;
  onSubmit: ((e: ISubmitEvent<any>, nativeEvent: React.FormEvent<HTMLFormElement>) => any) | undefined;
  onCancel: () => void;
};

const inferType = (value: any): string => {
  if (typeof value === 'string') return 'string';
  if (typeof value === 'number') return 'number';
  if (typeof value === 'boolean') return 'boolean';
  if (Array.isArray(value)) return 'array';
  return 'string';
};
const generateSchemaFromData = (title: string, data: any) => {
  const keys = Object.keys(data);

  const schema: any = {
    type: 'object',
    properties: {},
    title,
  };

  keys.forEach((key: string) => {
    schema.properties[key] = {
      type: inferType(data[key]),
      title: key,
    };
  });

  return schema;
};



const appendNewProperties = (schema: any, metadata: any): any => {
 
  const updatedSchema: any = {
    ...schema,
    properties: { ...schema.properties },
  };


  for (const [key, value] of Object.entries(updatedSchema.properties)) {
    const property = value as any;

   
    if (!property.filespin_properties || property.filespin_properties.searchable !== true) {

      delete updatedSchema.properties[key];
    }
  }


  return updatedSchema;
};

const ensureSchemaVersion = (schema: any) => {
  const updatedSchema = { ...schema };

  delete updatedSchema.$schema;

  // Add the Draft-07 schema identifier
  updatedSchema.$schema = 'http://json-schema.org/draft-07/schema#';

  return updatedSchema;
};
export const SearchForm: React.FC<SearchFormProps> = ({ className, schema, metadata, onSubmit, onCancel, ...rest }) => {
  const { formatMessage } = useIntl();

  let formSchema = schema;

  //   console.log(schema)
  if (!schema) {
    const schemaTitle = formatMessage(messages.customSchema);
    formSchema = generateSchemaFromData(schemaTitle, metadata);
  } else {
    formSchema = appendNewProperties(schema, metadata);
    formSchema = ensureSchemaVersion(formSchema);
    const validation = validateFormData(metadata, formSchema);
    if (validation.errors.length > 0) {
      formSchema = appendNewProperties(schema, metadata);
      // Sentry.captureMessage(`Schema Errors: ${validation.errors.toString()}`, Sentry.Severity.Error);
    }
  }

  return (
    <div className={cn([styles.SearchForm, className])}>
      <SearchFormData schema={formSchema} formData={metadata} onSubmit={onSubmit} onCancel={onCancel} />
    </div>
  );
};

export default SearchForm;
